import React from "react";
import ContentNewPassword from "../Content/ContentNewPassword";

const NewPassword = () => {
  return <ContentNewPassword />;
};

export default NewPassword;
